import { Button, Flex } from 'antd';
import { FC, PropsWithChildren } from 'react';
import * as Icon from 'react-feather';
import styled from 'styled-components';

export interface DynamicFormRowProps {
  count: number;
  index: number;
  onAddAlternative: () => void;
  onRemoveAlternative: () => void;
  onViewAlternative?: (index: number) => void;
}

export const DynamicFormRow: FC<PropsWithChildren<DynamicFormRowProps>> = ({
  children,
  count,
  index,
  onAddAlternative,
  onRemoveAlternative,
  onViewAlternative,
}) => {
  return (
    <Flex gap="middle">
      {children}
      <FlexWrapper gap="small" align="end" $first={index === 0}>
        <StyledButton
          id={`show-alternative-${index}`}
          icon={
            <Icon.Eye size={18} onClick={() => onViewAlternative?.(index)} />
          }
          disabled={!onViewAlternative}
        />
        {index >= count - 1 && (
          <StyledButton
            id={`add-alternative-${index}`}
            icon={<Icon.Plus size={18} />}
            onClick={onAddAlternative}
          />
        )}
        <StyledButton
          id={`remove-alternative-${index}`}
          icon={<Icon.Minus size={18} />}
          onClick={onRemoveAlternative}
        />
      </FlexWrapper>
    </Flex>
  );
};

const FlexWrapper = styled(Flex)<{ $first?: boolean }>`
  max-height: ${({ $first = true }) => ($first ? '62px' : '32px')};
`;

const StyledButton = styled(Button)`
  .ant-btn-icon {
    height: 18px;
  }
`;
